import React from 'react'
import navLogo from 'modules/assets/images/nav-logo.svg'
import errorGraphic from 'modules/assets/images/error-graphic.svg'
import Button from 'modules/ui/Button'
import styles from './DefaultErrorPage.scss'

export function DefaultErrorPage({
  title = 'Something went wrong...',
  messages = [
    'Sorry, an error has occurred and we are looking into the issue.',
    'Please reload the page or try again later',
  ],
}) {
  return (
    <div className={styles.defaultErrorPage}>
      <div className={styles.logoContainer}>
        <a href="/" alt="Home page">
          <img className={styles.logo} src={navLogo} alt="Navigation logo" />
        </a>
      </div>
      <div className={styles.content}>
        <img
          src={errorGraphic}
          className={styles.errorGraphic}
          alt="Car stopped on highway"
        />
        <div className={styles.textContent}>
          <h1 className={styles.title}>{title}</h1>
          <div className={styles.copy}>
            {messages.map((message, index) => (
              <div key={index}>
                {message.includes('Please try again') && <br />}
                <p>{message}</p>
              </div>
            ))}
          </div>
          <a href="/" alt="Back to Dashboard">
            <Button label="Back to Dashboard" />
          </a>
        </div>
      </div>
    </div>
  )
}
